
import { useMemo } from "react";
import { Category } from "@/types/assessment";

export interface ChartDataPoint {
  name: string;
  current: number;
  target: number;
}

export function useChartData(
  categories: Category[], 
  scoresByCategory: Record<string, {current: number, target: number}>
) {
  // Transform the data for the radar chart
  const chartData = useMemo(() => {
    if (!categories || categories.length === 0) {
      return [];
    }
    
    // If scoresByCategory is empty, try to get from localStorage
    let workingScores = scoresByCategory;
    if (Object.keys(scoresByCategory).length === 0) {
      const savedScores = localStorage.getItem('assessment-results-scores');
      if (savedScores) {
        try {
          workingScores = JSON.parse(savedScores);
        } catch (error) {
          console.error('useChartData: Error parsing saved scores:', error);
        }
      }
    }
    
    const result = categories.map(category => {
      const scores = workingScores[category.id] || { current: 0, target: 0 };
      
      // Ensure scores are valid numbers within the 0-4 range
      // If current/target is undefined, NaN, or null, default to 0
      const currentScore = Number.isFinite(scores.current) 
        ? Math.min(4, Math.max(0, scores.current)) 
        : 0;
        
      const targetScore = Number.isFinite(scores.target) 
        ? Math.min(4, Math.max(0, scores.target)) 
        : 0;
      
      return {
        name: category.name,
        current: currentScore,
        target: targetScore,
        fullMark: 4
      };
    });
    
    return result;
  }, [categories, scoresByCategory]);
  
  return chartData;
}
